import Contact from '../home/contactnow'
import Timer from'../../assets/contact/time.gif'
import Book from '../../assets/contact/book.gif'
import location from '../../assets/contact/destination-map.gif'
const contactform =()=>{
    return(
        <>
            <div className="container-fluid">
                <div className="container servicesContent" style={{padding:'50px'}}>
                    {/* <div
                        class="row justify-content-center align-items-center g-2 mb-5"
                    >
                        <div class="col-md-4 p-2 ">
                            <div style={{height:'200px', backgroundColor:'white', boxShadow:'8px 8px black',}} className='border border-primary d-flex justify-content-center align-items-center'>
                                <div>
                                    <p className='text-dark'>Timing</p>
                                    <p className='text-dark'><img src={Timer} alt="timer clock" style={{width:'70px',height:'70px'}}/> Mon-Fri - 10:00 Am to 7:00 Pm</p>    
                                </div>        
                            </div>
                        </div>
                        <div class="col-md-4 p-2">
                             <div style={{height:'200px', backgroundColor:'white', boxShadow:'8px 8px black',}} className='border border-primary d-flex justify-content-center align-items-center'>
                                <div>
                                    <p className='text-dark'>Contact</p>
                                    <p className='text-dark'><img src={Book} alt="timer clock" style={{width:'70px',height:'70px'}}/>+91-8700364602</p>    
                                </div>        
                            </div>
                        </div>
                        <div class="col-md-4 p-2">
                             <div style={{height:'200px', backgroundColor:'white', boxShadow:'8px 8px black',}} className='border border-primary d-flex justify-content-center align-items-center'>
                                <div>
                                    <p className='text-dark'>Timing</p>
                                    <p className='text-dark'><img src={location} alt="timer clock" style={{width:'70px',height:'70px'}}/>,K-2nd 553,Devli,Sangam Vihar,<br/>New Delhi,India</p>    
                                </div>        
                            </div>
                        </div>
                    </div> */}
                    
                    
                    
                    <Contact/>
                </div>
            </div>
        </>
    )
}

export default contactform